<!-- RODAPÉ PADRÃO -->
<link
  rel="stylesheet"
  type="text/css"
  href="https://www.saopaulo.sp.gov.br/barra-govsp/css/rodape-padrao-govsp.min.css"
/>
<section id="govsp-rodape" aria-labelledby="rodape-title">
  <div class="container">
    <div class="linha-botoes">
      <div class="coluna-4">
        <a
          href="https://www.ouvidoria.sp.gov.br/Portal/Default.aspx"
          class="btn btn-model"
          aria-label="Acessar a Ouvidoria do Governo de São Paulo"
          >Ouvidoria</a
        >
      </div>

      <div class="coluna-4">
        <a
          href="http://www.transparencia.sp.gov.br/"
          class="btn btn-model"
          aria-label="Acessar o Portal da Transparência do Governo de São Paulo"
          >Transparência</a
        >
      </div>

      <div class="coluna-4">
        <a
          href="http://www.sic.sp.gov.br/"
          class="btn btn-model"
          aria-label="Acessar o Serviço de Informação ao Cidadão (SIC) do Governo de São Paulo"
          >SIC</a
        >
      </div>
    </div>
  </div>

  <div class="container rodape" *ngIf="!periodoEleitoral">
    <div class="logo-rodape">
      <p>
        <a
          href="https://www.saopaulo.sp.gov.br/"
          aria-label="Ir para o site oficial do Governo de São Paulo"
        >
          <img
            src="./assets/img/logo-SPgov-sec-educacao-page.svg"
            alt="Logo do Governo de São Paulo - Secretaria de Educação"
            width="318"
          />
        </a>
      </p>
    </div>
  </div>
</section>
